import React, { useState } from "react";
import GradientButton from "../../Buttons/GradientButton/GradientButton";
import NftInteractionModal from "../NftInteractionModal/NftInteractionModal";
import StyledSmText from "../../../common/components/styledSmText/StyledSmText";
import StyledMdText from "../../../common/components/styledMdText/StyledMdText";
import StyledH3Heading from "../../../common/components/styledH3Heading/StyledH3Heading";
import { useRemindMe } from "../../../Hooks/api/useRemindMe";

const EarlyAccessModal = ({ closeModal }) => {
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  const [inputEmail, setInputEmail] = useState("");
  const [isInputValid, setIsInputValid] = useState(true);
const {mutate ,isPending}=useRemindMe()
  const handleInputChange = (e) => {
    const email = e.target.value;
    setInputEmail(email);
    setIsInputValid(validEmail(email));
  };

  const handleButtonClick = () => {
    if (!isInputValid) {
      return;
    }
    mutate(
      { email: inputEmail },
      { 
        onSuccess: () => {
          closeModal();
        }
      }
    );
  };
  

  const validEmail = (email) => {
    return emailRegex.test(email);
  };

  return (
    <NftInteractionModal
      handleClose={closeModal}
      width={"w-[95%] sm:w-4/5 md:w-4/6 lg:w-1/2 xl:w-[40%]"}
      content={
        <div className="flex flex-col gap-3 py-10 px-5 sm:px-10 xl:px-10">
          <div className="flex flex-col justify-center items-center text-center mb-4 gap-2 ">
            <StyledH3Heading fontColor={"textGradient"}>
              Early Access
            </StyledH3Heading>

       <div className="px-10">
       <StyledMdText>
              Secure your spot in digital history with early access to our
              exclusive NFT collection launch!
            </StyledMdText>
       </div>
          </div>
          <div className="space-y-2">
          <div className="relative flex flex-col md:flex-row justify-center items-center gap-4 w-full">
            <div className="relative overflow-x-hidden w-[100%]">
              <input
                type="email"
                value={inputEmail}
                onChange={handleInputChange}
                // className={`h-full w-full text-md border border-bright-yellow rounded-md text-white px-3 py-[27px] pr-20 md:pr-32 bg-transparent focus:outline focus:outline-bright-yellow
                // }`}
                className="w-[100%] text-md border border-bright-yellow rounded-md text-white px-3 h-[55px] pr-36 bg-transparent focus:outline focus:outline-bright-yellow"

                placeholder="Enter email"
                maxLength={40}
              />
            </div>
            {inputEmail.length>0 && !isInputValid && (
            <StyledSmText fontColor="text-red-600 text-left self-start md:absolute bottom-[-50%] left-0">
              Please enter a valid email address
            </StyledSmText>
          )}
            <GradientButton
              onClick={handleButtonClick}
              disabled={!isInputValid || isPending || !inputEmail.length>0}
              fontColor={"w-full md:w-auto md:absolute md:right-[5px] md:top-1.5 !px-[25px] !py-[10px]"}
              children={"Remind Me"}
            />
          </div>
         
          </div>
        </div>
      }
    />
  );
};

export default EarlyAccessModal;
